import Map from "./Map";
import { Dealer } from "../data/models";
import WorkingHours from "./WorkingHours";
import Button from "./Button";

export interface StoreInfoProps {
  dealer: Dealer;
}

export function StoreInfo(props: StoreInfoProps) {
  const { dealer } = props;
  return (
    <div className="flex flex-col sm:flex-row justify-between p-6 gap-[40px] lg:gap-[60px] bg-[#F1F2F3] rounded-xl">
      <div className="flex flex-col flex-1 lg:gap-[60px] gap-8 lg:flex-row">
        <div className="flex flex-col flex-1 gap-4 lg:gap-6">
          <h3 className="font-medium text-[22px] sm:text-2xl text-gray-extra-dark">
            Distributer
          </h3>
          <hr className="w-full border-t-1 border-[#E0E3E5]" />

          <div className="flex flex-col justify-between gap-3">
            <h4 className="font-bold uppercase text-md text-gray-extra-dark">{dealer.name}</h4>
            <span className="text-base text-gray-extra-dark text-opacity-80">
              {dealer.street && (
                <>
                  {dealer.street},&nbsp;{dealer.postal_code}&nbsp;
                  {dealer.city}
                </>
              )}
            </span>
          </div>
          <a href={dealer.url} target="_blank" rel="noopener noreferrer">
            <Button
              text="Posjetite stranicu distributera"
              variant="secondary"
              size="base"
            />
          </a>
        </div>

        <div className="flex flex-col flex-1 gap-4 lg:gap-6">
          <h3 className="font-medium text-[22px] sm:text-2xl text-gray-extra-dark">
            Radno vrijeme
          </h3>
          <hr className="w-full border-t-1 border-[#E0E3E5]" />
          {dealer.working_hours.monday ? (
            <div className="flex flex-col gap-3">
              <WorkingHours day="pon" hours={dealer.working_hours.monday} />
              <WorkingHours day="uto" hours={dealer.working_hours.tuesday} />
              <WorkingHours day="sri" hours={dealer.working_hours.wednesday} />
              <WorkingHours day="čet" hours={dealer.working_hours.thursday} />
              <WorkingHours day="pet" hours={dealer.working_hours.friday} />
              <WorkingHours day="sub" hours={dealer.working_hours.saturday} />
              <WorkingHours day="ned" hours={dealer.working_hours.sunday} />
            </div>
          ) : (
            <div className="text-base f text-gray-extra-dark text-opacity-80">
              Trenutno nema informacija o radnom vremenu.
            </div>
          )}
        </div>
      </div>
      <div className="lg:w-[601px] lg:h-[388px] sm:w-[313px] sm:h-[486px] h-[250px]">
        <Map
          city={dealer.city}
          street={dealer.street}
          postalCode={dealer.postal_code}
          dealer={dealer.name}
        ></Map>
      </div>
    </div>
  );
}

export default StoreInfo;
